export default __webpack_public_path__ + "static/media/AstronautImg.b42d159a.png";